export const columnFunc = () => {
  $('.p-column-cat__display').click(function () {
    $(this).toggleClass('is--open');

    if ( $(this).hasClass('is--open') ) {
      $(this).next().stop().slideDown(200);
    } else {
      $(this).next().stop().slideUp(200);
    }
  });

  const cta = $( '.p-column-article__cta' );
  cta.each( function ( i ) {
    if ( i == 0 ) {
      const sns = $('.p-column-article__sns').clone(true);
      $( this ).after( sns );
    }
  } );
}
